// extracted by mini-css-extract-plugin
export var sliderDots = "styles-module--sliderDots--45pqx";
export var slickActive = "styles-module--slick-active--nc+6G";